import React, { useState, useRef, useContext} from "react";

import {BackHandler, View, Text, TextInput, Alert}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import contexto from '../util/contexto'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import Botao from '../componentes/Botao'

import {buscarCategorias, novaDenuncia} from '../ws/ws_denuncia'

import {carregamento} from '../componentes/Carregamento'

import {MSG_ERRO_PADRAO, TELA_PRINCIPAL} from '../util/constantes'

import RotuloErro from '../componentes/RotuloErro'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Combo from '../componentes/Combo'






export default function TelaNovaDenuncia(){
   
	const {valorContexto} = useContext(contexto);

	const navegacao = new useNavigation();
	
	const [sincronizando, setSincronizando] = useState(true) 

	const [categoria, setCategoria] = useState(null)
	const [comentario, setComentario] = useState(null)
	const [msgErro, setMsgErro] = useState(null)
	const [listaCategorias, setListaCategorias] = useState([])
	
	const btSalvarRef = useRef();
	
	const cbCategoriaRef = useRef();

	

	const voltar = () => {
		navegacao.replace(util.processaVoltar())
		return true
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaNovaDenuncia");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	useFocusEffect(React.useCallback(() => {
	
		if(cbCategoriaRef.current)
			cbCategoriaRef.current.setDados(listaCategorias);
		
	}, [sincronizando]));


	const buscarDados= async ()=>{

		setSincronizando(true);
		
		let aux = await buscarCategorias();
		
		let lista = [];
		
		if(util.temConteudo(aux))
			aux.forEach(item => lista.push({"id": item[0], "nome": item[1]}));

		setListaCategorias(lista)
			
		setSincronizando(false)
	}

	
	async function salvar(){
		
		btSalvarRef.current.setCarregando(true)
        
		setMsgErro(null);
		
		if(categoria ==null){

            salvarErro("Selecione a categoria.");
            return;
        } 
		
		let aux  = await novaDenuncia(valorContexto.idUsuarioAtual, 
										valorContexto.tipoDenuncia, 
											valorContexto.idRelacaoDenuncia, 
												categoria, 
													comentario);
		
		if(aux == null || aux.id ==null){
                
			salvarErro(MSG_ERRO_PADRAO);
            return; 
        }

		btSalvarRef.current.setCarregando(false);

		Alert.alert("Sucesso", 'Sua denúncia foi recebia com sucesso.');

		navegacao.replace(TELA_PRINCIPAL)
    }


	function salvarErro(mensagem){
		
        btSalvarRef.current.setCarregando(false);
		setMsgErro(mensagem);
    }


	return (
		<ViewDegradeVertical titulo="Denúncia" voltar={()=>voltar()}>
			{(sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 	
					<Bloco todaArea={true}>  
						<View style={{marginTop:20}}/>	
						<View style={{alignItems:'center'}}>
							<Text style={estilos.rotulo_titulo}>Nova Denúncia</Text>
						</View>
						<View style={{marginTop:40}}/>	
						<Combo 
							rotulo="Selecione a Categoria:" 
							selecionado={categoria} 
							dados={[]} 
							aoMudar={(valor)=>setCategoria(valor.id)} 
							ref={cbCategoriaRef}/>
						
						<View style={{marginTop:30}}/>	

						<Text style={estilos.rotulo_padrao}>Comentário (opcional):</Text>
									
						<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={true}
							numberOfLines = {4}
							onChangeText={(text)=>setComentario(text)}
							maxLength={250}
							value={comentario}/>
						
						<View style={{marginTop:30}}/> 

						{util.temConteudo(msgErro) && 
							<View style={{alignItems:'center'}}>
								<RotuloErro mensagem={msgErro}/>
							</View>
						}	
						
						<View style={{marginTop:20}}/> 
						
						<View style={{alignItems:'center'}}>
							<Botao 
								acao={()=>salvar()}
								texto="Enviar Denúncia"
								ref={btSalvarRef}/>    
						</View>

						<View style={{marginTop:40}}/> 

						<View style={{alignItems:'center'}}>
							<Text style={estilos.rotulo_menor}>Sua denúncia é anônima, a parte denunciada não será notificada e nem receberá nenhuma informação sobre o denunciante.</Text>
						</View>
					</Bloco>
				</Scroll>)
			}
		</ViewDegradeVertical>	
	);
}